import type {
    FruitSliceListenerDefinition,
    FruitSliceListenerMeta,
} from '@fruitful/types';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetcher } from '../../http/Fetcher';

const listenerPath = (sliceId: string): string =>
    `/api/admin/fruit-slices/${encodeURIComponent(sliceId)}/listeners`;

export const useListFruitSliceListeners = (sliceId: string) => {
    return useQuery<FruitSliceListenerMeta[], Error>({
        queryKey: ['fruitSliceListeners', sliceId],
        queryFn: async () =>
            await fetcher<FruitSliceListenerMeta[]>({
                endpoint: listenerPath(sliceId),
            }),
        enabled: sliceId.length > 0,
    });
};

export const useGetFruitSliceListener = (
    sliceId: string,
    listenerId: string,
) => {
    return useQuery<FruitSliceListenerDefinition, Error>({
        queryKey: ['fruitSliceListeners', sliceId, listenerId],
        queryFn: async () =>
            await fetcher<FruitSliceListenerDefinition>({
                endpoint: `${listenerPath(sliceId)}/${encodeURIComponent(listenerId)}`,
            }),
        enabled: sliceId.length > 0 && listenerId.length > 0,
    });
};

export const useSimulateFruitSliceListener = (
    sliceId: string,
    listenerId: string,
) => {
    return useMutation<
        unknown,
        Error,
        { event: string; data?: Record<string, unknown> }
    >({
        mutationFn: async (body) =>
            await fetcher({
                endpoint: `${listenerPath(sliceId)}/${encodeURIComponent(listenerId)}/simulate`,
                method: 'POST',
                body: JSON.stringify(body),
            }),
    });
};
